export const RESET_MESSAGE = 'RESET_MESSAGE';
export const SET_MESSAGE = 'SET_MESSAGE';

export function resetMessage(name) {
  return {
    type: RESET_MESSAGE,
    name,
  };
}

export function setMessage(name, messageType, message) {
  return {
    type: SET_MESSAGE,
    name,
    messageType,
    message,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/messages.js